import Model from '@/models/Model.js';

export default class CourseGrade extends Model {
    static entity = 'course_grades';

    static modelName = 'CourseGrade';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            user_id: this.attr(null),
            course_enrolment_id: this.attr(null),
            points: this.attr(null),
            automatic: this.attr(null),
            grading_scheme_id: this.attr(null),
            grading_scheme_criteria_id: this.attr(null),
            overridden: this.attr(null),
            override_reason: this.attr(null),
            comments: this.attr(null),
            published_at: this.attr(null),
            notified_support_at: this.attr(null),
            percentage_value: this.attr(null),
            grading_scheme: this.attr(null),
            grading_scheme_criteria: this.attr(null),
            remediation: this.attr(null),
            statuses: this.attr(null),
            has_been_remediated: this.attr(null),
            is_passing: this.attr(null),

            ...super.fields(),
            course: this.belongsTo('courses', 'course_id'),
            user: this.belongsTo('users', 'user_id'),
            course_enrollment: this.belongsTo('course_enrollments', 'course_id'),
            // These should probably be snake_case
            gradingScheme: this.belongsTo('grading_schemes', 'grading_scheme_id'),
            gradingSchemeCriteria: this.belongsTo('grading_scheme_criterias', 'grading_scheme_criteria_id'),
        };
    }

    get name() {
        return this.published_at ? 'published grade' : 'unpublished grade';
    }
}
